import { Button, InputAdornment, MenuItem } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { RHFTextField } from '../hook-form';

const GeneralSelectMenu = ({ label, name, value, onChangeValue, options, readOnly = false, hasButton = false, onClick, btnTitle }) => {
  const theme = useTheme();

  const getBgColor = () => {
    if (theme.palette.mode === 'light') {
      return 'grey.200';
    }
    return '[#3e3d3d]';
  };

  return (
    <RHFTextField
      fullWidth
      select
      label={label}
      name={name}
      value={value}
      onChange={(event) => onChangeValue(event?.target?.value)}
      SelectProps={{
        MenuProps: {
          sx: { '& .MuiPaper-root': { maxHeight: 400 } },
        },
        sx: {
          backgroundColor: readOnly ? getBgColor() : '',
          '& .MuiSelect-select': {
            backgroundColor: readOnly ? getBgColor() : '',
          },
        },
        inputProps: { readOnly },
      }}
      InputProps={{
        endAdornment: hasButton ? (
          <InputAdornment position="end">
            <Button size="small" color="inherit" variant="contained" sx={{ mr: 2, fontSize: '12px' }} onClick={onClick}>
              {btnTitle}
            </Button>
          </InputAdornment>
        ) : null,
      }}
    >
      {options?.map((option) => (
        <MenuItem
          key={option?.id}
          value={option?.id}
          sx={{
            mx: 1,
            my: 0.5,
            borderRadius: 0.75,
            typography: { xs: 'overline', md: 'body2' },
            textTransform: 'capi1talize',
          }}
        >
          {option?.title}
        </MenuItem>
      ))}
    </RHFTextField>
  );
};

export default GeneralSelectMenu;
